import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import loadWishLists from "@insite/client-framework/Store/Pages/MyLists/Handlers/LoadWishLists";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Search from "@insite/mobius/Icons/Search";
import TextField, { TextFieldProps } from "@insite/mobius/TextField";
import { PunchoutSecretPageContext } from "@TKCCP/Pages/PunchoutSecretPage";
import loadPunchouts from "@TKCCP/Store/Data/PunchoutSecretService/Handlers/LoadPunchoutSecretHandler";
import updateLoadParameter from "@TKCCP/Store/Pages/PunchoutSecret/Handlers/UpdateLoadParameter";
import ApplicationStateTKCCP from "@TKCCP/Store/TKCCPState";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {}

const mapStateToProps = (state: ApplicationStateTKCCP) => {
    return {
        query: state.pagePunchoutSecret.getPunchoutParameter.query,
    };
};

const mapDispatchToProps = {
    updateLoadParameter,
    loadPunchouts,
};

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface MyListsSearchBoxStyles {
    search?: TextFieldProps;
    container?: GridContainerProps;
    searchGridItem?: GridItemProps;
}

export const searchBoxStyles: MyListsSearchBoxStyles = {
    container: {
        css: css`
            margin-top: 25px;
            > div {
                margin-bottom: 10px;
            }
        `,
    },
    search: {
        iconProps: { src: Search },
    },
    searchGridItem: {
        width: [12, 12, 6, 6, 5],
    },
};

interface PunchoutSecretSearchBoxState {
    query?: string;
}

const styles = searchBoxStyles;

class PunchoutSecretSearchBox extends React.Component<Props, PunchoutSecretSearchBoxState> {
    private searchTimeoutId?: ReturnType<typeof setTimeout>;

    constructor(props: Props) {
        super(props);
        this.state = {
            query: props.query,
        };
    }

    handleChange = (event: React.FormEvent<HTMLInputElement>, props: Props) => {
        if (typeof this.searchTimeoutId === "number") {
            clearTimeout(this.searchTimeoutId);
        }

        const query = event.currentTarget.value;
        this.setState({ query });

        this.searchTimeoutId = setTimeout(() => {
            props.updateLoadParameter({ query });
        }, 250);
    };

    render() {
        return (
            <GridContainer {...styles.container}>
                <GridItem {...styles.searchGridItem}>
                    <TextField
                        data-test-selector="myListsSearchByCompany"
                        placeholder={translate("Search lists by Company & Shared Secret")}
                        {...styles.search}
                        value={this.state.query}
                        onChange={(event: React.FormEvent<HTMLInputElement>) => this.handleChange(event, this.props)}
                    ></TextField>
                </GridItem>
            </GridContainer>
        );
    }
}

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(PunchoutSecretSearchBox),
    definition: {
        group: "Order History",
        displayName: "Punchout Secret Search Box",
        // allowedContexts: [PunchoutSecretPageContext],
    },
};

export default widgetModule;
